import React, { useEffect, useState } from "react";
import { ShieldOff, Download } from "lucide-react";
import { toast } from "sonner";
import { api, AYLAR } from "@/lib/api";
import { saveBlob } from "@/components/payroll/bankUtils";

const ROLE = { admin: "Admin", yonetici: "Yönetici", muhasebeci: "Muhasebeci", muhasebe_stj: "Muhasebe Stj.", junior_muhasebe: "Junior Muhasebe", personel: "Personel" };
const fmtAt = (iso) => new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export function AccessDeniedPanel() {
  const now = new Date();
  const [yil, setYil] = useState(now.getFullYear());
  const [ay, setAy] = useState(now.getMonth() + 1);
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get("/access-denied", { params: { yil, ay } }).then((r) => setData(r.data)).catch(() => setData({ total: 0, rows: [], users: [] }));
  }, [yil, ay]);

  const exportXlsx = async () => {
    try { saveBlob(await api.get("/access-denied/export", { params: { yil, ay }, responseType: "blob" }), `Yetkisiz Erisim ${yil}-${ay}.xlsx`); }
    catch { toast.error("Excel indirilemedi"); }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 md:p-5 shadow-sm" data-testid="access-denied-panel">
      <div className="flex items-center gap-2 flex-wrap mb-3">
        <h2 className="font-display text-base md:text-lg font-bold text-slate-900 flex items-center gap-2">
          <ShieldOff size={18} className="text-rose-600" /> Yetkisiz Erişim Denemeleri
          {data && <span className="text-xs font-bold bg-rose-600 text-white rounded-full px-2 py-0.5" data-testid="access-denied-total">{data.total}</span>}
        </h2>
        <select value={ay} onChange={(e) => setAy(Number(e.target.value))} data-testid="access-denied-month"
          className="ml-auto px-2 py-1 border border-slate-300 rounded-md text-xs bg-white">
          {AYLAR.map((a) => <option key={a.v} value={a.v}>{a.n}</option>)}
        </select>
        <select value={yil} onChange={(e) => setYil(Number(e.target.value))} data-testid="access-denied-year"
          className="px-2 py-1 border border-slate-300 rounded-md text-xs bg-white">
          {[now.getFullYear() - 1, now.getFullYear()].map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
        <button type="button" onClick={exportXlsx} disabled={!data?.total} data-testid="access-denied-export"
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-emerald-700 hover:bg-emerald-800 text-white text-xs font-semibold disabled:opacity-40">
          <Download size={12} /> Excel
        </button>
      </div>
      <p className="text-xs text-slate-500 mb-3">Kullanıcıların rolleri gereği açamadıkları sayfa veya verilere yaptığı istekler. Aynı gün 5 denemede size ayrıca uyarı düşer.</p>
      {!data && <div className="text-xs text-slate-400">Yükleniyor...</div>}
      {data && !data.total && <div className="text-xs italic text-slate-400" data-testid="access-denied-empty">Bu ay yetkisiz erişim denemesi yok.</div>}
      {data?.total > 0 && (
        <>
          <div className="flex flex-wrap gap-2 mb-3" data-testid="access-denied-users">
            {data.users.map((u, i) => (
              <span key={i} className="text-xs bg-rose-50 border border-rose-200 text-rose-800 rounded-full px-2.5 py-0.5">
                <b>{u.name}</b> · {ROLE[u.role] || u.role} · {u.count}
              </span>
            ))}
          </div>
          <div className="overflow-x-auto max-h-80 overflow-y-auto">
            <table className="w-full text-xs">
              <thead className="sticky top-0 bg-slate-50 text-slate-500 uppercase text-[10px]">
                <tr><th className="text-left p-2">Kullanıcı</th><th className="text-left p-2">Sayfa / Veri</th><th className="text-right p-2">Deneme</th><th className="text-right p-2">Gün</th><th className="text-left p-2">İlk</th><th className="text-left p-2">Son</th></tr>
              </thead>
              <tbody>
                {data.rows.map((g, i) => (
                  <tr key={i} className="border-t border-slate-100" data-testid={`access-denied-row-${i}`}>
                    <td className="p-2"><div className="font-semibold text-slate-800">{g.name}</div><div className="text-slate-500">{ROLE[g.role] || g.role}</div></td>
                    <td className="p-2 font-mono text-[11px] text-slate-700 break-all"><span className="text-slate-400">{g.method}</span> {g.path}</td>
                    <td className="p-2 text-right font-bold text-rose-700">{g.count}</td>
                    <td className="p-2 text-right">{g.days}</td>
                    <td className="p-2 whitespace-nowrap">{fmtAt(g.first_at)}</td>
                    <td className="p-2 whitespace-nowrap">{fmtAt(g.last_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
